<template>
  <b-form-group
    id="admire-campaign-select-group"
    :label="$t('integration.admire_campaign_label', 'Campaign(s) to Sync With: (required)')"
    label-for="admire-campaign-select"
  >
    <multiselect
      id="admire-campaign-select"
      v-model="selectedCampaigns"
      :options="campaignOptions"
      :multiple="true"
      :taggable="false"
      track-by="id"
      :custom-label="(c) => `[${c.id}] ${c.title}`"
      :disabled="syncPending"
      :placeholder="$t('integration.admire_campaign_placeholder', 'Select campaign(s)')"
    ></multiselect>

    <b-form-checkbox v-model="syncPending" class="admire-campaign-select__pending">
      {{ $t("integration.admire_campaign_later", "Will set later") }}
    </b-form-checkbox>

    <small class="form-text text-muted">
      {{
        $t(
          "integration.admire_campaign_note",
          'Donations from the selected campaign(s) are sent to Admire. If none are ready yet, check "Will set later" - you\'ll need to come back and set at least one before donations can sync.'
        )
      }}
    </small>
  </b-form-group>
</template>

<script>
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";

export default {
  name: "AdmireCampaignSelect",

  components: {
    Multiselect,
  },

  props: {
    value: {
      type: Object,
      default: () => ({ campaignIds: [], campaignSyncPending: false }),
    },
  },

  data() {
    return {
      selectedCampaigns: [],
      syncPending: Boolean(this.value?.campaignSyncPending),
      hydrated: false,
    };
  },

  computed: {
    ...mapState({
      campaigns: (s) => s.campaigns.campaigns,
    }),

    campaignOptions() {
      return this.campaigns.map((c) => ({ id: c.id, title: c.attributes.title }));
    },
  },

  watch: {
    campaignOptions: {
      immediate: true,
      handler(options) {
        if (this.hydrated || !options.length) {
          return;
        }
        const ids = (this.value?.campaignIds || []).map((id) => Number(id));
        if (!ids.length) {
          return;
        }
        this.selectedCampaigns = options.filter((o) => ids.includes(Number(o.id)));
        this.hydrated = true;
      },
    },

    selectedCampaigns(val) {
      if (val.length) {
        this.syncPending = false;
      }
      this.emitChange();
    },

    syncPending(val) {
      if (val) {
        this.selectedCampaigns = [];
      }
      this.emitChange();
    },
  },

  mounted() {
    this.$store.dispatch("getCampaigns");
  },

  methods: {
    emitChange() {
      this.$emit("input", {
        campaignIds: this.selectedCampaigns.map((c) => Number(c.id)),
        campaignSyncPending: this.syncPending,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.admire-campaign-select__pending {
  margin-top: 0.5rem;
}
</style>
